import React, { useRef, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { resendOTP, verifyOTP } from "../../slices/1-auth/1-login/thunk";
import { useNavigate } from "react-router-dom";
import { EnvelopeIcon } from "@heroicons/react/24/outline";
import logo from "../../assets/images/Logo.webp";
import { useTranslation } from "react-i18next";
import MainButton from "../sharedComponents/MainButton";

const OTPForm = () => {
  const dispatch = useDispatch();
  const inputsRef = useRef([]);
  const [timer, setTimer] = useState(60);
  const [isTimerRunning, setIsTimerRunning] = useState(false);
  const [otpCode, setOtpCode] = useState(["", "", "", "", "", ""]);

  const { otpLoading, resendLoading } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const { t } = useTranslation();

  const formContent = {
    title: t("otp.title"),
    subtitle: t("otp.subtitle"),
    signInText: t("otp.verify"),
    text: t("otp.resendIn"),
    Iconlock: (
      <EnvelopeIcon className="w-12 h-12 p-3 rounded-full dark:text-primary text-primary-light dark:bg-bg-dark-secondary bg-bg-light-secondary" />
    ),
  };

  const {
    title,
    subtitle,
    otpPlaceholder,
    signInText,
    Iconlock,
    text
  } = formContent;
  useEffect(() => {
    setIsTimerRunning(true);
  }, []);


  // TIMER
  useEffect(() => {
    if (!isTimerRunning || timer <= 0) return;
    const interval = setInterval(() => {
      setTimer((prev) => prev - 1);
    }, 1000);
    return () => clearInterval(interval);
  }, [isTimerRunning, timer]);

  const handleResend = () => {
    const storedUser = localStorage.getItem("authUser");
    const parsedUser = storedUser ? JSON.parse(storedUser) : null;
    const userEmail = parsedUser?.data?.email;
    if (!userEmail) {
      // toast.error("No email to resend");
      return;
    }

    dispatch(resendOTP(userEmail));
    setOtpCode("")
    setTimer(60);
    setIsTimerRunning(true);
  };

  const minutes = Math.floor(timer / 60);
  const seconds = timer % 60;

  // const handleChange = (e, index) => {
  //   const value = e.target.value;
  //   if (/^\d$/.test(value)) {
  //     const newOtp = otpCode.split("");
  //     newOtp[index] = value;
  //     setOtpCode(newOtp.join(""));
  //     if (index < 5) inputsRef.current[index + 1]?.focus();
  //   } else {
  //     e.target.value = "";
  //   }
  // };

  const handleChange = (e, index) => {
    const value = e.target.value;

    if (!/^\d?$/.test(value)) return;

    const newOtp = [...otpCode];
    newOtp[index] = value;
    setOtpCode(newOtp);

    if (value && index < 5) {
      inputsRef.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      const newOtp = [...otpCode];

      if (!otpCode[index] && index > 0) {
        inputsRef.current[index - 1]?.focus();
      }

      newOtp[index] = "";
      setOtpCode(newOtp);
    }
  };


  const handleVerify = async (e) => {
    e.preventDefault();

    if (otpCode?.join("").length < 6) {
      toast.error(t("otp.errors.invalidLength"));
      return;
    }

    try {
      const result = await dispatch(
        verifyOTP({ otp: otpCode?.join("") })
      ).unwrap();

      if (result?.success || result?.status === "success") {
        toast.success(t("otp.success"));

        // console.log(result)
        if (result.data.token) {
          const authUser = {
            status: "success",
            data: {
              token: `Bearer ${result.data.token}`,
            },
          };

          localStorage.setItem("authUser", JSON.stringify(authUser));
          navigate("/", { replace: true });

        }
      } else {
        // toast.error(result?.message || "Verification failed");
      }
    } catch (error) {
      // toast.error(error?.message || t("otp.errors.invalid"));
    }
  };

  // console.log(otpCode)
  return (
    <div className="grid min-h-screen grid-cols-1 md:grid-cols-2 ">
      {/* Left Side */}
      <div className="flex-col items-center justify-center hidden min-h-screen text-center md:flex dark:bg-bg-dark-secondary bg-bg-light-secondary">
        {/* Logo Circle */}
        <div className="">
          <img
            src={logo}
            alt={t("login.logoAlt")}
            className="flex items-center justify-center mb-6 rounded-full w-28 h-28 shadow-glow"
          />
        </div>

        {/* Texts */}
        <h1 className="mb-4 text-3xl font-bold text-black dark:text-white">{t("login.brandName")}</h1>
        <p className="px-4 text-center text-text-muted-light dark:text-text-muted-dark">
          {t("login.brandSubtitle")}
        </p>
      </div>

      {/* RIGHT FORM */}
      <div className="flex items-center justify-center px-6 ">
        <div className="w-full max-w-md">
          <span className="inline-block p-2 rounded-full">{Iconlock}</span>
          <h2 className="text-2xl font-bold text-custom-black">{title}</h2>
          <p className="mt-4 md:text-md text-text-muted-light dark:text-text-muted-dark">{subtitle}</p>

          <form className="flex flex-col gap-5 mt-6" onSubmit={handleVerify}>
            <div className="flex justify-between gap-0 my-5 md:gap-2" dir="ltr">
              {/* {[...Array(6)].map((_, index) => (
                <input
                  key={index}
                  type="text"
                  maxLength={1}
                  className="w-12 h-12 text-lg text-center border rounded-full dark:border-border-dark border-border-light dark:text-primary text-primary-light focus:outline-none dark:focus:border-primary focus:border-primary-light dark:bg-bg-dark-secondary bg-bg-light-secondary "
                  onChange={(e) => handleChange(e, index)}
                  ref={(el) => (inputsRef.current[index] = el)}
                />
              ))} */}
              {otpCode?.map((digit, index) => (
                <input
                  key={index}
                  type="text"
                  maxLength={1}
                  value={digit}
                  onChange={(e) => handleChange(e, index)}
                  onKeyDown={(e) => handleKeyDown(e, index)}
                  ref={(el) => (inputsRef.current[index] = el)}
                  className="w-12 h-12 text-lg text-center border rounded-full dark:border-border-dark border-border-light dark:text-primary text-primary-light focus:outline-none dark:focus:border-primary focus:border-primary-light dark:bg-bg-dark-secondary bg-bg-light-secondary "
                />
              ))}

            </div>

            <MainButton
              type="submit"
              disabled={otpLoading}
            >
              {otpLoading ? t("otp.verifying") : signInText}{" "}
            </MainButton>

            <div className="flex justify-between mt-3 text-sm">
              <div className="flex gap-1">
                <span>{text}</span>
                <span className="font-bold dark:text-primary text-primary-light">
                  {minutes}:{seconds.toString().padStart(2, "0")}
                </span>
              </div>

              <button
                type="button"
                disabled={resendLoading || timer > 0}
                onClick={handleResend}
                className={`font-semibold ${timer > 0
                  ? "text-gray-400 cursor-not-allowed"
                  : "dark:text-primary text-primary-light"
                  }`}
              >
                {resendLoading ? t("otp.sending") : t("otp.resend")}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default OTPForm;
